import { MoveRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { tokens } from "@/locales/translations/tokens";
import { useNavigate } from "@tanstack/react-router";

const ContactUsSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleStart = (path: string) => {
    navigate({ to: path || "/" })
  }

  return (
    <section
      id="footer-contact"
      className="relative w-full overflow-hidden bg-[radial-gradient(circle,_rgba(240,240,240,0.9)_0%,_rgba(200,200,200,0.4)_0%,_rgba(100,100,100,0.6)_100%)]"
    >
      {/* Overlay com imagem e blend */}
      <div className="absolute inset-0 z-0 bg-[url('/assets/patterns/abstract-connecting-dots-lines.jpg')] bg-cover bg-center opacity-5"></div>

      {/* Conteúdo */}
      <div className="relative z-10 flex flex-col items-center justify-center px-4 py-24 sm:px-6 lg:px-8 text-center max-w-6xl mx-auto">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight text-primary-foreground drop-shadow-lg">
          {t(tokens.landing.hero_title)}
        </h1>

        <p className="mt-4 text-lg sm:text-xl text-primary-foreground/80 max-w-xl">
          {t(tokens.landing.hero_subtitle)}
        </p>

        <div className="mt-8 w-full max-w-xs">
          <Button
            size="lg"
            className="w-full relative rounded-full font-semibold text-base uppercase bg-white text-neutral-800 hover:bg-neutral-200 transition-colors group"
            onClick={() => handleStart("/sign-in")}
          >
            {t(tokens.landing.get_demo)}
            <span className="absolute right-6 transition-all duration-300 opacity-0 translate-x-2 group-hover:translate-x-0 group-hover:opacity-100">
              <MoveRight className="h-5 w-5 text-blue-600" />
            </span>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ContactUsSection;